/**
* @file: 搜索框
* @author: wence
*/
import React, {PureComponent} from 'react';
import PropType from 'prop-types';

import './index.less';
export default class SearchBar extends PureComponent {
    static propTypes = {
        value: PropType.string,
        onChange: PropType.func,
        placeholder: PropType.string,
        isShowCancel: PropType.bool,
        onSubmit: PropType.func,
        onCancel: PropType.func,
        isShowClear: PropType.bool
    }

    static defaultProps = {
        isShowClear: true
    }

    static getDerivedStateFromProps(props, state) {
        if (('value' in props) && props.value !== state.value) {
            return {
                value: props.value
            };
        }

        return null;
    }

    constructor(props) {
        super(props);

        this.state = {
            value: ''
        };
    }

    onChange = e => {
        const value = e.target.value;
        const onChange = this.props.onChange;

        if (!('value' in this.props)) {
            this.setState({value});
        }

        onChange && onChange(value);
    }

    onSubmit = e => {
        e.preventDefault();

        const onSubmit = this.props.onSubmit;

        onSubmit && onSubmit(this.state.value);

        this.input && this.input.blur();
    }

    render() {
        const {placeholder, isShowCancel, isShowClear, ...restProps} = this.props;
        const value = this.state.value;

        return (
            <form onSubmit={this.onSubmit} className="cus-search-wrapper">
                <div className="cus-search">
                    <div className="cus-search-btn">
                        <img alt="icon" src={require('../../asset/svg/icon_search_btn.svg')} />
                    </div>
                    <input
                        ref={input => this.input = input}
                        className="cus-search-input"
                        {...restProps}
                        placeholder={placeholder}
                        type="search"
                        onChange={this.onChange}
                        value={value} />
                    {isShowClear && (value !== '' && value !== undefined && value !== null)
                        && <div className="cus-search-clear">
                            <img
                                alt="icon"
                                onClick={this.onChange.bind(this, {target: {value: ''}})}
                                src={require('../../asset/svg/icon_input clear.svg')} />
                        </div>}
                </div>
                {isShowCancel
                    && <div onClick={this.props.onCancel} className="cus-search-cancel">
                        取消
                    </div>}
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/searchBar/index.js